/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import styles from './WGCWXRewards.scss'

export const EVENT_REWARDS = (
    <FormattedMessage
        id='wgcwx_shop.rewards.event_rewards'
        defaultMessage='Награждение победителей'
    />
)

export const REWARDS_TANKS_SECTION = (
    <FormattedMessage
        id='wgcwx_shop.rewards.sections.tanks'
        defaultMessage='Призовая техника'
    />
)

const AUCTION_ACCESS = (
    <FormattedMessage
        id='wgcwx_shop.rewards.sections.auction_access'
        defaultMessage='допуск на аукцион техники'
    />
)

export const REWARDS_TANK_HAS_AUCTION_TICKET = topPlaces => (
    <FormattedMessage
        id='wgcwx_shop.rewards.has_auction_ticket.requirement'
        defaultMessage='Технику за фиксированное количество бон смогут получить игроки, вошедшие в {top} по итогам события. Вы уже собрали в Мастерской {access} для возможности получить призовые машины, делая ставки на аукционе. Необходимое количество личных Очков славы для получения техники станет известно после завершения события.'
        values={{
            access: (
                <span className={styles.highlight}>
                    {AUCTION_ACCESS}
                </span>
            ),
            top: (
                <span className={styles.highlight}>
                    {REWARDS_TANK_SELECTION_TOP(topPlaces)}
                </span>
            ),
        }}
    />
)

export const REWARDS_TANK_HAS_NO_AUCTION_TICKET = topPlaces => (
    <FormattedMessage
        id='wgcwx_shop.rewards.has_no_auction_ticket.requirement'
        defaultMessage='Технику за фиксированное количество бон смогут получить игроки, вошедшие в {top} по итогам события. Остальным игрокам необходимо собрать в Мастерской {access} для возможности получить призовые машины, делая ставки в боновом аукционе. Необходимое количество личных Очков славы для получения техники станет известно после завершения события.'
        values={{
            access: (
                <span className={styles.highlight}>
                    {AUCTION_ACCESS}
                </span>
            ),
            top: (
                <span className={styles.highlight}>
                    {REWARDS_TANK_SELECTION_TOP(topPlaces)}
                </span>
            ),
        }}
    />
)

const REWARDS_TANK_SELECTION_TOP = topPlaces => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.top'
        defaultMessage='топ-{top}'
        values={{ top: <FormattedNumber value={topPlaces} /> }}
    />
)

export const LACK_OF_BATTLES = (battlesPlayed, minBattles) => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.lack_of_battles'
        defaultMessage='Проведено боёв {battlesPlayed} / {minBattles}.'
        values={{ battlesPlayed, minBattles }}
    />
)

export const ENOUGH_PFP_FOR_TANK_RECEIVING = (dateTime, topPlaces) => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.enough_pfp_for_tank_receiving'
        defaultMessage='Поздравляем! Вы вошли в {top} игроков по итогам события и получили право на получение награды. Награждение будет доступно до {dateTime}.'
        values={{
            top: (
                <span className={styles.highlight}>
                    {REWARDS_TANK_SELECTION_TOP(topPlaces)}
                </span>
            ),
            dateTime: (<span className={styles.highlight}>{dateTime.format('L, LT')}</span>),
        }}
    />
)

export const NOT_ENOUGH_PFP_FOR_TANK_RECEIVING = dateTime => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.auction.not_enough_pfp_for_tank_receiving'
        defaultMessage='К сожалению, вы набрали недостаточное количество Очков славы в течение события, но вы можете использовать Боны для участия в аукционе за получение наград. Награждение будет доступно до {dateTime}.'
        values={{
            dateTime: (<span className={styles.highlight}>{dateTime.format('L, LT')}</span>),
        }}
    />
)

export const TANK_IS_IN_HANGAR = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.already_in_hangar'
        defaultMessage='В Ангаре'
    />
)

export const REWARD_RECEIVED = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.already_received'
        defaultMessage='Награда получена'
    />
)

export const OTHER_REWARD_SELECTED = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.other_reward_selected'
        defaultMessage='Награда уже выбрана'
    />
)

export const PFP_NAME = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.pfp_name'
        defaultMessage='Очки славы'
    />
)

export const AUCTION_START_FROM = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.auction.start_from'
        defaultMessage='Аукцион от'
    />
)

export const AUCTION_BET_APPLIED = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.auction.bet_applied'
        defaultMessage='Принята ставка'
    />
)

export const EVENT_FINISHED_HAS_NO_AUCTION_TICKET = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank_receiving.event_finished_has_no_auction_ticket'
        defaultMessage='Вы не собрали в Мастерской допуск на аукцион техники для получения призовых машин за боны.'
        values={{
            access: (
                <span className={styles.highlight}>
                    {AUCTION_ACCESS}
                </span>
            ),
        }}
    />
)




// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewards/translations.jsx